var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.loaded)?_c(_vm.componentName,{key:_vm.componentName,tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }